import { cn } from '@/lib/utils'
import plainLockup from '@/assets/brand-lockup.svg?raw'
import lhLockup from '@/assets/lh-brand-lockup.svg?raw'
import uatLockup from '@/assets/uat-brand-lockup.svg?raw'

/**
 * The MNTND lockup (mark + wordmark) for this environment (board PB-U10):
 * localhost shows the LH badge, UAT the UAT badge, production none. An
 * unknown build mode gets the LH one, so a wrong build shows a badge.
 */
const BY_MODE: Record<string, string> = {
  development: lhLockup,
  uat: uatLockup,
  production: plainLockup,
}

const INK = '#2B2B30'
const BADGE = '#E5BF59'

/**
 * Inline the SVG so the mark and wordmark take the text colour (light and
 * dark mode). The badge's own letters stay dark on yellow: they are the paths
 * right after the badge shape, inside the mark (x < 100, the wordmark starts
 * at x 114).
 */
function themed(svg: string): string {
  let inBadge = false
  return svg
    .replace(/\swidth="\d+"\sheight="\d+"/, '')
    .replace(/<path\b[^>]*>/g, tag => {
      if (tag.includes(BADGE)) {
        inBadge = true
        return tag
      }
      const x = Number(/\sd="M\s*([\d.]+)/.exec(tag)?.[1] ?? 0)
      if (inBadge && x < 100) return tag
      inBadge = false
      return tag.replace(`fill="${INK}"`, 'fill="currentColor"')
    })
}

const LOCKUP = themed(BY_MODE[import.meta.env.MODE] ?? lhLockup)

/** Size it with a height class (`h-7`); the width follows. */
export function BrandLockup({ className }: { className?: string }) {
  return (
    <span
      role="img"
      aria-label="MNTND"
      className={cn(
        'inline-flex text-foreground [&>svg]:h-full [&>svg]:w-auto',
        className
      )}
      dangerouslySetInnerHTML={{ __html: LOCKUP }}
    />
  )
}
